import { render, staticRenderFns } from "./NavbarChangeAccount.vue?vue&type=template&id=b0dda6b8&"
import script from "./NavbarChangeAccount.vue?vue&type=script&lang=js&"
export * from "./NavbarChangeAccount.vue?vue&type=script&lang=js&"
import style0 from "./NavbarChangeAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports